import {Component} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Lang, LocaleService} from '../../services/locale.service';
import {AuthService} from '../../auth/services/auth.service';


@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent {

    languages: Lang[] = LocaleService.languages;

    currentLang: Lang;

    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
            map(result => result.matches)
        );

    constructor(
        private breakpointObserver: BreakpointObserver,
        private localeService: LocaleService,
        private authService: AuthService
    ) {
        this.setDefaultLang();
    }

    setDefaultLang(lang?: Lang | string) {
        this.currentLang = this.localeService.setDefaultLang(lang);
    }

    logout() {
        this.authService.logout().subscribe(() => {
            window.location.href = '/';
        });
    }
}
